import { referencedNodeValue } from "../schemas/shared/valueConfig.ts";

const isNodeValueRefTo = (value: unknown, nodeId: number): boolean => referencedNodeValue(value)?.nodeId === nodeId;

/**
 * Reset (to `undefined`) every configured value within `config` that is a node-value
 * reference to `nodeId` — used when that node is deleted so nothing dangles.
 * A node-referencing value is always optional, so consumers must cope with the
 * resulting `undefined` (falling back or reading as unset). Mutates in place;
 * deep-walks nested objects and arrays, since configured values sit under arbitrary keys
 * (e.g. a condition/effect build config's compared-to value). Raw literals and
 * external ValueConfigs are left untouched.
 */
export const resetNodeValueRefs = (config: unknown, nodeId: number): void => {
  const walk = (node: unknown) => {
    if (Array.isArray(node)) {
      node.forEach((item, index) => {
        if (isNodeValueRefTo(item, nodeId)) {
          node[index] = undefined;
        } else {
          walk(item);
        }
      });
      return;
    }
    if (typeof node !== "object" || node === null) return;
    for (const [key, value] of Object.entries(node)) {
      if (isNodeValueRefTo(value, nodeId)) {
        (node as Record<string, unknown>)[key] = undefined;
      } else {
        walk(value);
      }
    }
  };

  walk(config);
};
